import React from "react";
import { useMutation } from "react-query";
import { notify } from "frontend/src/features/notifications";
import { uploadZip } from "frontend/src/api/tracks/upload";
var userTracksAvailableFileTypes = ["zip"];
var useUploadZip = function () {
    var _a = React.useState(false), isSuccessLoading = _a[0], setIsSuccessLoading = _a[1];
    var _b = useMutation(uploadZip, {
        onSuccess: function () {
            notify({ variant: "success", message: "Файл сохранен" }); //показывает сообщение о загрузке более 5-ти секунд, сократить это время
            setIsSuccessLoading(true);
            // return queryClient.invalidateQueries(cacheKey);
        },
    }), mutate = _b.mutate, isLoading = _b.isLoading, error = _b.error;
    return { run: mutate, isLoading: isLoading, error: error, isSuccessLoading: isSuccessLoading };
};
var maxFileSizeInMegabytes = 512;
export var usePageModel = function () {
    var uploadedFile = useUploadedFileEdit();
    // do file upload
    var uploadZipFile = useUploadZip();
    var onFileFormSubmit = function (evt) {
        evt.preventDefault();
        var file = uploadedFile.file.value;
        if (uploadedFile.validate().length === 0 && file) {
            uploadZipFile.run({
                file: file,
                metadata_source: uploadedFile.metadataSource.value,
                artist_title_filename_separator: uploadedFile.artistTitleFilenameSeparator.value
            });
        }
        else if (uploadedFile.validate()) {
            notify({ variant: "error", message: "" + uploadedFile.validate() });
        }
    };
    return { uploadedFile: uploadedFile, onFileFormSubmit: onFileFormSubmit, uploadZipFile: uploadZipFile };
};
var useUploadedFileEdit = function () {
    var _a = React.useState(""), fileTitle = _a[0], setFileTitle = _a[1];
    var _b = React.useState(null), file = _b[0], setFile = _b[1];
    var _c = React.useState("filename"), metadataSource = _c[0], setMetadataSource = _c[1];
    var _d = React.useState(" - "), artistTitleFilenameSeparator = _d[0], setArtistTitleFilenameSeparator = _d[1];
    var _e = React.useState(false), hasUploadedFile = _e[0], setHasUploadedFile = _e[1];
    var _f = React.useState([]), errors = _f[0], setErrors = _f[1];
    // const hasUploadedFile = file !== null;
    var onFileInputChange = function (evt) {
        var files = evt.target.files;
        if (files) {
            setFile(files[0]);
            setFileTitle(files[0].name);
            setHasUploadedFile(true);
        }
        else {
            setFile(null);
            setHasUploadedFile(false);
        }
    };
    var validate = function () {
        var _a;
        var validation = [];
        if (!file) {
            validation.push("Загрузите файл.");
        }
        if (artistTitleFilenameSeparator.length === 0) {
            validation.push("Введите название.");
        }
        if (file &&
            !userTracksAvailableFileTypes.includes((_a = file.name.split(".").pop()) !== null && _a !== void 0 ? _a : "")) {
            validation.push("\u0424\u0430\u0439\u043B \u0434\u043E\u043B\u0436\u0435\u043D \u0438\u043C\u0435\u0442\u044C \u043E\u0434\u043D\u043E \u0438\u0437 \u0441\u043B\u0435\u0434\u0443\u044E\u0449\u0438\u0445 \u0440\u0430\u0441\u0448\u0438\u0440\u0435\u043D\u0438\u0439: " + userTracksAvailableFileTypes.join(", "));
        }
        if (file && file.size / (1024 * 1024) > maxFileSizeInMegabytes) {
            validation.push("\u041C\u0430\u043A\u0441\u0438\u043C\u0430\u043B\u044C\u043D\u043E \u0434\u043E\u043F\u0443\u0441\u0442\u0438\u043C\u044B\u0439 \u0440\u0430\u0437\u043C\u0435\u0440 \u0444\u0430\u0439\u043B\u0430 - " + maxFileSizeInMegabytes + " \u041C\u0411.");
        }
        setErrors(validation);
        return validation;
    };
    return {
        metadataSource: { value: metadataSource, set: setMetadataSource },
        artistTitleFilenameSeparator: { value: artistTitleFilenameSeparator, set: setArtistTitleFilenameSeparator },
        fileTitle: { value: fileTitle, set: setFileTitle },
        file: { value: file, set: setFile, onChange: onFileInputChange },
        hasUploadedFile: { value: hasUploadedFile, set: setHasUploadedFile },
        errors: errors,
        validate: validate,
    };
};
